/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {ContactId, ContactInput} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getEditLeadContactUrl = (id: string, contactId: ContactId) => {
  return `/api/v1/sales/leads/${id}/contacts/${contactId}`;
};

/**
 * @summary Edit lead contact
 */
export const editLeadContact = async (
  id: string,
  contactId: ContactId,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getEditLeadContactUrl(id, contactId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};

export const getRemoveLeadContactUrl = (id: string, contactId: ContactId) => {
  return `/api/v1/sales/leads/${id}/contacts/${contactId}`;
};

/**
 * @summary Remove lead contact
 */
export const removeLeadContact = async (
  id: string,
  contactId: ContactId,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRemoveLeadContactUrl(id, contactId), {
    ...options,
    method: "DELETE",
  });
};

export const getAddLeadContactUrl = (id: string) => {
  return `/api/v1/sales/leads/${id}/contacts`;
};

/**
 * @summary Add lead contact
 */
export const addLeadContact = async (
  id: string,
  contactInput: ContactInput,
  options?: Parameters<typeof customFetch>[1],
): Promise<ContactId> => {
  return customFetch<ContactId>(getAddLeadContactUrl(id), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(contactInput),
  });
};
